import { PageContainer } from "src/components/organisms/contents";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import {
  usePointRegister,
  useUserRegister,
} from "src/common/hooks/useUserRegister";
import { useMemo, useState } from "react";
import dayjs from "dayjs";
import { SubConHeader } from "src/components/atoms/SubHeaderBox/SubConHeader";
import { RenderPagination } from "./components/RenderPagination";

interface styleProps {
  $bgColor?: string;
}

export const HeaderBox = styled.div<styleProps>`
  /* width: 100vw; */
  max-width: 45rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  margin: 0 -16px;
  background-color: ${(props) => (props.$bgColor ? props.$bgColor : "#F7F7F7")};
  box-sizing: border-box;

  svg {
    cursor: pointer;
  }

  path {
    stroke: #000;
  }
`;

const tab = ["적립", "사용", "소멸"];

export const HealthPointPage = () => {
  const navi = useNavigate();
  const [activeTab, setActiveTab] = useState<string>("적립");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const itemsPerPage = 15;

  /* tab에 맞는 데이터 필터링 */

  const { data: userInfo } = useUserRegister();

  const { data: pointData = [] } = usePointRegister();

  const filtered = pointData[0]?.histories?.filter(
    (item: any) => item.pointCategory === activeTab
  );

  const nearestExpirationDate = dayjs(
    pointData[0]?.nearestExpirationDate
  ).format("YYYY.MM.DD");

  // 전체 페이지 수 계산
  const totalPages = Math.ceil(filtered?.length / itemsPerPage);

  // 현재 페이지에 해당하는 데이터 slice
  const paginatedData = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    return filtered?.slice(start, end);
  }, [filtered, currentPage]);

  return (
    <PageContainer isNavBar={false} active={null}>
      <>
        {/* 헤더 */}
        <SubConHeader
          $bgColor="#fff"
          title="건강 포인트"
          onClickArrow={() => navi(-1)}
        />

        {/* 상단 내용 */}
        <div
          style={{
            // width: "100vw",
            maxWidth: "45rem",
            padding: 16,
            margin: "0 -16px",
            background: "white",
            boxShadow: "0px 2px 10px -4px rgba(0, 0, 0, 0.04)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: 30,
          }}
        >
          <div
            style={{
              width: "100%",
              alignSelf: "stretch",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: 16,
            }}
          >
            <div
              style={{
                width: "100%",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 4,
                display: "flex",
              }}
            >
              <div
                style={{
                  justifyContent: "flex-start",
                  alignItems: "center",
                  display: "flex",
                  fontSize: 14,
                  color: "var(--neutral-500, #737373)",
                }}
              >
                <div style={{ fontSize: 14, fontWeight: "700" }}>
                  {userInfo?.userName} 님
                </div>
                <div style={{ fontWeight: "500" }}>의 건강 포인트</div>
              </div>

              {/* 소지 포인트 */}
              <div
                style={{
                  textAlign: "center",
                  justifyContent: "space-between",
                  display: "flex",
                  gap: 6,
                }}
              >
                <span
                  style={{
                    color: "#F57C00",
                    fontSize: 24,
                    fontWeight: "700",
                    lineHeight: "32px",
                  }}
                >
                  {pointData[0]?.currentPoint.toLocaleString()}
                </span>
                <span
                  style={{
                    color: "var(--neutral-700, #404040)",
                    fontSize: 24,
                    fontWeight: "700",
                    lineHeight: "32px",
                  }}
                >
                  P
                </span>
              </div>
            </div>

            {/* 소멸예정 포인트 */}
            <div
              style={{
                width: "100%",
                paddingTop: 8,
                borderTop: "1px var(--neutral-200, #E5E5E5) solid",
                flexDirection: "column",
                gap: 4,
                display: "flex",
                fontSize: 14,
                fontWeight: "500",
                color: "var(--neutral-400, #A3A3A3)",
              }}
            >
              <div
                style={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <span>소멸예정 포인트</span>
                <span>{pointData[0]?.expiringIn30Days} P</span>
              </div>
              <div
                style={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <span>소멸 예정일</span>
                <span>{nearestExpirationDate}</span>
              </div>
            </div>
          </div>
        </div>

        {/* 하단 버튼 및 기록 */}
        <div
          style={{
            // width: "100vw",
            maxWidth: "45rem",
            padding: "0 16px",
            margin: "24px -16px 0",
            flexDirection: "column",
            display: "flex",
            gap: 8,
            marginTop: 24,
          }}
        >
          <div
            style={{
              display: "grid",
              justifyContent: "start",
              gridTemplateColumns: "repeat(5, 1fr)",
              gap: 8,
              fontSize: 16,
              fontWeight: "500",
              lineHeight: "24px",
            }}
          >
            {/* 탭 메뉴 */}
            {tab.map((item) => (
              <div
                key={item}
                onClick={() => setActiveTab(item)}
                data-active="on"
                data-icon="false"
                style={{
                  padding: "4px 12px",
                  background:
                    activeTab === item
                      ? "var(--neutral-700, #404040)"
                      : "#E5E5E5",
                  borderRadius: 50,
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                  cursor: "pointer",
                }}
              >
                <div
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                    color:
                      activeTab === item
                        ? "var(--neutral-50, #FAFAFA)"
                        : "#a3a3a3",
                  }}
                >
                  {item}
                </div>
              </div>
            ))}
          </div>

          {/* 포인트 기록 */}
          <div
            style={{
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
            }}
          >
            {paginatedData?.map((item: any) => {
              const date = dayjs(item.createdAt).format("YYYY-MM-DD HH:mm");
              return (
                <div
                  key={item.oid}
                  style={{
                    width: "100%",
                    height: 90,
                    padding: "0 16px",
                    borderBottom: "1px var(--neutral-200, #E5E5E5) solid",
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      flexDirection: "column",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      gap: 4,
                      fontWeight: "500",
                      display: "flex",
                    }}
                  >
                    <div
                      style={{
                        color: "var(--neutral-400, #A3A3A3)",
                        fontSize: 13,
                        lineHeight: "20px",
                      }}
                    >
                      {date}
                    </div>
                    <div
                      style={{
                        color: "var(--neutral-700, #404040)",
                        fontSize: 16,
                        lineHeight: "24px",
                      }}
                    >
                      {item.description}
                    </div>
                  </div>
                  <div
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 4,
                      display: "flex",
                    }}
                  >
                    <div
                      style={{
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: 2,
                        display: "flex",
                        color: item.pointChange > 0 ? "#E66F00" : "#737373",
                        fontSize: 16,
                        fontWeight: "700",
                        lineHeight: "24px",
                      }}
                    >
                      {item.pointChange}P
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          {/* 페이지 표시 로직 */}
          {totalPages > 1 && (
            <RenderPagination
              totalPages={totalPages}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          )}
        </div>
      </>
    </PageContainer>
  );
};
